const EPS = 1e-4;
function clamp01(n) {
    if (!Number.isFinite(n))
        return 0;
    return Math.min(1, Math.max(0, n));
}
/** Validate a raw crop object: 4 finite numbers, positive size, inside [0,1]. */
export function isValidCrop(value) {
    if (!value || typeof value !== "object")
        return false;
    const c = value;
    const { x, y, w, h } = c;
    if (typeof x !== "number" ||
        typeof y !== "number" ||
        typeof w !== "number" ||
        typeof h !== "number") {
        return false;
    }
    if (![x, y, w, h].every((n) => Number.isFinite(n)))
        return false;
    if (w <= 0 || h <= 0)
        return false;
    if (x < -EPS || y < -EPS)
        return false;
    if (x + w > 1 + EPS || y + h > 1 + EPS)
        return false;
    return true;
}
/** Clamp a crop rectangle into [0,1] keeping a positive size. */
export function clampCrop(crop) {
    const x = clamp01(crop.x);
    const y = clamp01(crop.y);
    const w = Math.min(1 - x, Math.max(0, Number.isFinite(crop.w) ? crop.w : 0));
    const h = Math.min(1 - y, Math.max(0, Number.isFinite(crop.h) ? crop.h : 0));
    return { x, y, w, h };
}
/** Read a valid, clamped crop from a layer, or null when absent/invalid. */
export function getLayerCrop(layer) {
    const raw = layer.style?.crop;
    if (!isValidCrop(raw))
        return null;
    return clampCrop(raw);
}
/** Whether the layer carries a valid crop. */
export function hasLayerCrop(layer) {
    return getLayerCrop(layer) !== null;
}
/**
 * Aspect ratio (w/h) of the cropped region given the natural bitmap aspect.
 * `naturalAspect` = naturalWidth / naturalHeight.
 */
export function cropAspect(crop, naturalAspect) {
    if (crop.h <= 0 || naturalAspect <= 0)
        return naturalAspect;
    return (crop.w / crop.h) * naturalAspect;
}
